import { useQuery } from '@tanstack/react-query';

import Transition from '@/components/Common/Transition';
import { useModalContext } from '@/components/Modal/Modal';
import queryKeys from '@/configs/react-query-keys';
import service from '@/services/index';
import { TOPIC_2_TYPE } from '@/types/taxonomyConst';

import EditAiTopic from './AiTopic/AiTopicSettingModal/EditAiTopic';
import EditManualTopic from './ManualTopic/EditManualTopic';
import EditRuleTopic from './RuleTopic/EditRuleTopic';
import SavedTopicSetting from './SavedTopic/SavedTopicSetting';
import StaticTopicSettings from './StaticTopicSettings';
import type { EditTopicModalProps } from './types';
import createTopicUtils from './utils';

const EditTopicModal = (props: EditTopicModalProps) => {
  const { closeModal } = useModalContext();
  const { data, isFetched } = useQuery({
    queryKey: [...queryKeys.taxonomy.TOPIC_DETAIL, props.alias],
    queryFn: () => service.taxonomy.fetchTopicDetail(props.alias),
  });

  if (props.static)
    return <StaticTopicSettings topic={data} closeModal={closeModal} />;

  return (
    <Transition status={isFetched} style={{ maxWidth: 'calc(100vw - 96px)' }}>
      {data?.category === TOPIC_2_TYPE.AI && (
        <EditAiTopic
          {...props}
          initialTopic={data}
          target={data?.level === 1 ? 'taxonomy' : 'topic'}
          targetTopicAlias={createTopicUtils.getTargetTopicAlias(data)}
          closeModal={closeModal}
          static={props.static}
        />
      )}
      {data?.category === TOPIC_2_TYPE.RULE && (
        <EditRuleTopic
          {...props}
          initialTopic={data}
          closeModal={closeModal}
          static={props.static}
        />
      )}
      {data?.category === TOPIC_2_TYPE.MANUAL && (
        <EditManualTopic
          {...props}
          initialTopic={data}
          closeModal={closeModal}
          static={props.static}
        />
      )}
      {data?.category === TOPIC_2_TYPE.SAVED_TOPIC && (
        <SavedTopicSetting
          {...props}
          initialTopic={data}
          closeModal={closeModal}
        />
      )}
    </Transition>
  );
};

export default EditTopicModal;
